import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
import { useCycleAvailability } from './useCycleAvailability';
import { useCycleDefaultDecision } from './useCycleDefaultDecision';
export const useSelectedCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    isCycleAvailable,
    isLoading: isCycleAvailabilityLoading
  } = useCycleAvailability(selectedProductId || undefined, selectedCycle || undefined);
  const {
    servedCycle,
    isLoading
  } = useCycleDefaultDecision();
  if (!isLoading && (!selectedCycle || !isCycleAvailable && !isCycleAvailabilityLoading)) {
    module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId(servedCycle));
    return servedCycle;
  }
  return selectedCycle || undefined;
};
//# sourceMappingURL=useSelectedCycle.js.map